import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlService} from '../url.service';

@Injectable()
export class SupervisorDashboardService {
    private BASE_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/supervisorDashboard';
    }

    // Supervisor Dashboard Methods
    getSupervisorAggregateData(dataProfileId: string, orgUnitId: string): Observable<any> {
        let params = new HttpParams();
        params = params.set('orgUnitId', orgUnitId);
        const requestOptions = {
            params: params
        };

        return this.http.get(this.BASE_URL + '/aggregateOverview/' + dataProfileId, requestOptions);
    }

    getSupervisorPageOneData(dataProfileId: string, orgUnitId: string): Observable<any> {
        let params = new HttpParams();
        params = params.set('orgUnitId', orgUnitId);
        const requestOptions = {
            params: params
        };

        return this.http.get(this.BASE_URL + '/pageOne/' + dataProfileId + '/user', requestOptions);
    }

    getSupervisorPageOneClientData(dataProfileId: string, orgUnitId: string, userId: string): Observable<any> {
        let params = new HttpParams();
        params = params.set('orgUnitId', orgUnitId);
        params = params.set('userId', userId);
        const requestOptions = {
            params: params
        };

        return this.http.get(this.BASE_URL + '/pageOne/' + dataProfileId + '/client', requestOptions);
    }

    getSupervisorPageTwoUserData(dataProfileId: string, orgUnitId: string): Observable<any> {
        let params = new HttpParams();
        params = params.set('orgUnitId', orgUnitId);
        const requestOptions = {
            params: params
        };

        return this.http.get(this.BASE_URL + '/pageTwo/' + dataProfileId + '/user', requestOptions);
    }

    getSupervisorPageTwoClientData(dataProfileId: string, orgUnitId: string, userId: string): Observable<any> {
        let params = new HttpParams();
        params = params.set('orgUnitId', orgUnitId);
        params = params.set('userId', userId);
        const requestOptions = {
            params: params
        };

        return this.http.get(this.BASE_URL + '/pageTwo/' + dataProfileId + '/client', requestOptions);
    }

    getSupervisorPageThreeData(dataProfileId: string, orgUnitId: string): Observable<any> {
        let params = new HttpParams();
        params = params.set('orgUnitId', orgUnitId);
        const requestOptions = {
            params: params
        };

        return this.http.get(this.BASE_URL + '/pageThree/' + dataProfileId + '/detail', requestOptions);
    }

    getSupervisorPageThreeClientData(dataProfileId: string, orgUnitId: string, userId: string): Observable<any> {
        let params = new HttpParams();
        params = params.set('orgUnitId', orgUnitId);
        params = params.set('userId', userId);
        const requestOptions = {
            params: params
        };

        return this.http.get(this.BASE_URL + '/pageThree/' + dataProfileId + '/client', requestOptions);
    }

    getSupervisorPageFiveData(dataProfileId: string, orgUnitId: string): Observable<any> {
        let params = new HttpParams();
        params = params.set('orgUnitId', orgUnitId);
        const requestOptions = {
            params: params
        };

        return this.http.get(this.BASE_URL + '/pageFive/' + dataProfileId + '/detail', requestOptions);
    }

    getSupervisorDashboardAvailableOrgUnits(dataProfileId: string): Observable<any> {
        return this.http.get(this.BASE_URL + '/availableOrgUnits/' + dataProfileId);
    }
}
